import { Card, CardContent, Stack, Typography } from "@mui/material";
import { ClipboardTypography } from "@packsize/components";
import { type FC } from "react";
import { FormattedMessage } from "react-intl";
import { useToast } from "@packsize/toast";
import { useToken } from "@packsize/authentication";

export const PermissionsCard: FC = () => {
	const { toastSuccess, toastError } = useToast();
	const { decodedToken } = useToken();

	if (decodedToken === null) {
		return null;
	}

	return (
		<Card id="developer-permissions">
			<CardContent>
				<Typography variant="h3" component="h2" gutterBottom>
					<FormattedMessage id="Permissions" defaultMessage="Permissions" />
				</Typography>
				<Stack spacing={2}>
					{decodedToken.role.map((role) => (
						<ClipboardTypography
							key={role}
							variant="body1"
							onSuccess={() => toastSuccess({ message: "Copied to clipboard" })}
							onError={() => toastError({ message: "Failed to copy to clipboard" })}
						>
							{role}
						</ClipboardTypography>
					))}
				</Stack>
			</CardContent>
		</Card>
	);
};
